import { render, staticRenderFns } from "./PatientModalAnonymize.vue?vue&type=template&id=e1af6b24"
import script from "./PatientModalAnonymize.vue?vue&type=script&lang=js"
export * from "./PatientModalAnonymize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports